import { Toaster } from "react-hot-toast";

export default function Toast({ type, text }) {
  return (
    <Toaster
      position="top-right"
      containerStyle={{
        top: 100,
      }}
      toastOptions={{
        success: {
          style: {
            background: "#f0fdf4",
            color: "#15803d",
          },
          iconTheme: {
            primary: "#4ade80",
            secondary: "white",
          },
        },
        error: {
          style: {
            background: "#fee2e2",
            color: "#b91c1c",
          },
          iconTheme: {
            primary: "#f87171",
            secondary: "white",
          },
        },
      }}
    />
  );
}
